import { Box, Grid, Theme, useTheme } from '@mui/material';
import { MinorHeading } from '../../shared/typography/PrimaryTypography';
import { ResourceFilterContext } from '../../../views/resource_centre/ResourceCentreHome';
import PrimaryDivider from '../../shared/decoration/PrimaryDivider';

export interface QuickLink {
  label: string;
  compound_filters: ResourceFilterContext;
}

interface QuickLinksBarProps {
  quick_links: Array<QuickLink>;
  handleFiltersChange: (new_filters: ResourceFilterContext) => void;
}

/**
 * Display quick links in a uniform and styled way for Resource Centre Home context.
 * @param {Array<QuickLink>} quick_links List of quick link items to display in bar.
 * @param {(new_filters: ResourceFilterContext): void} handleFiltersChange Update resource filters in parent component with compound filters from quick links.
 * @returns {JSX.Element}
 */
const QuickLinksBar = ({ handleFiltersChange, quick_links }: QuickLinksBarProps) => {
  const theme: Theme = useTheme();

  return (
    <Box sx={{ width: '100%', backgroundColor: theme.palette.primary.light, px: 4, py: 1.5 }}>
      <Grid container spacing={0} sx={{ alignItems: 'center' }}>
        <Grid size={'auto'} sx={{ display: 'flex', alignItems: 'center' }}>
          <MinorHeading weight="Medium">Quick Links</MinorHeading>
          <PrimaryDivider orientation="vertical" sx={{ height: 40, mx: 3 }} />
        </Grid>
        {quick_links.map((quick_link: QuickLink, i: number) => (
          <Grid size={'auto'} key={quick_link.label}>
            <Box
              onClick={() => handleFiltersChange(quick_link.compound_filters)}
              sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            >
              <MinorHeading>{quick_link.label}</MinorHeading>
              {i < quick_links.length - 1 && (
                <PrimaryDivider orientation="vertical" sx={{ height: 35, mx: 3 }} opacity={0.5} />
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default QuickLinksBar;
